<!--  -->
<template>
  <div class="tw-w-full tw-flex tw-flex-col">
    <span class="tw-text-base tw-text-textMain tw-font-bold tw-py-3 tw-px-4">{{
      $t("个人中心")
    }}</span>

    <MobileSelectItem
      v-for="item in navItems"
      :key="item.id"
      :item="item"
      @onSelect="handleToDetail"
      :isShowIcon="false"
      :isShowDesc="false"
    />
  </div>
</template>
<script>
import MobileSelectItem from "./components/MobileSelectItem.vue";
export default {
  name: "MobilePersonalMenu",
  props: {},
  components: { MobileSelectItem },
  data() {
    return {
      navItems: [
        {
          id: 1,
          name: "个人设置",
          path: "/controlCenter/personal-setting",
        },
        {
          id: 10,
          name: "我的反馈",
          path: "/controlCenter/my-feedback",
        },
        {
          id: 2,
          name: "账号认证",
          path: "/controlCenter/account-authentication",
        },
        {
          id: 3,
          name: "我的订单",
          path: "/controlCenter/my-order",
        },
        {
          id: 4,
          name: "续订管理",
          path: "/controlCenter/renewal-management",
        },
        {
          id: 5,
          name: "后续费管理",
          path: "/controlCenter/postpaid-list",
        },
        {
          id: 6,
          name: "账单管理",
          path: "/controlCenter/bill-management",
        },
        {
          id: 7,
          name: "优惠券管理",
          path: "/controlCenter/coupon-management",
        },
        {
          id: 9,
          name: "解除限制",
          path: "/controlCenter/unfreeze-astrict",
        },
        {
          id: 8,
          name: "购物车",
          path: "/controlCenter/shopping-cart",
        },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    handleToDetail(item) {
      // TODO 账号认证
      if (item.path == "/controlCenter/account-authentication") {
        this.$toast(this.$t("暂未开放"), {
          type: "center",
          timeout: 1000,
        });
        return;
      }
      this.$emit("handleToDetail", item);
      this.$router.push(item.path);
      this.$store.commit("SET_CURRENTSTEP", null);
      this.$store.commit("SET_ORDERTYPE", null);
    },
  },
};
</script>

<style lang="scss" scoped></style>
